import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import Swal from "sweetalert2";

import {
  getUserLocations,
  getMiniProductList,
} from "../../../store/Mini/actions";
import {
  getSRTimelLinereportslist,
  SRTimelLinereportslistSuccessful,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
  getSRTimelineCSVExport,
} from "../../../store/Reports/actions";

const date = new Date();
const y = date.getFullYear();
const m = date.getMonth();

class SRTimelLineReports extends Component {
  constructor(props) {
    super(props);
    this.ReportsChangeHandeler = this.ReportsChangeHandeler.bind(this);
  }

  componentDidMount() {
    this.props.getUserLocations();
    this.props.SetParams({});
    console.log("SRTimeLineReports mounted - initial params:", this.props.params);
  }

  ReportsChangeHandeler(e) {
    this.props.ReportsChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }

  SelecteChangeValue({ key, label, key2, value }) {
    this.props.ReportsSelecteChangeValue({
      key,
      label,
      key2,
      value,
    });

    // Removed document-specific API call
  }

  reportType(e) {
    this.props.reportTypeCheck({ value: e.target.value });
    this.props.SRTimelLinereportslistSuccessful([]);

    if (e.target.value === "document") {
      const docParams = {
        ...this.props.params,
        start_date:
          this.props.params.start_date ||
          moment(new Date(y, m, 1)).format("YYYY-MM-DD"),
        end_date:
          this.props.params.end_date || moment(new Date()).format("YYYY-MM-DD"),
      };
      console.log("Requesting SR timeline (document) with params:", docParams);
      this.props.getSRTimelLinereportslist(docParams);
    }
  }

  handleGenerateReport = () => {
    // Check if location is selected
    if (!this.props.params?.location) {
      Swal.fire({
        icon: "warning",
        title: "Location Required",
        text: "Please select a location before generating the report.",
      });
      return;
    }

    console.log(
      "Generating document report with SR ID:",
      this.props.params.sr_id,
    );
  };

  handleDownloadCSV = () => {
    // Check if location is selected
    if (!this.props.params?.location) {
      Swal.fire({
        icon: "warning",
        title: "Location Required",
        text: "Please select a location before downloading the CSV report.",
      });
      return;
    }

    const csvParams = {
      ...this.props.params,
      start_date:
        this.props.params.start_date ||
        moment(new Date(y, m, 1)).format("YYYY-MM-DD"),
      end_date:
        this.props.params.end_date || moment(new Date()).format("YYYY-MM-DD"),
    };
    console.log("Downloading SR timeline CSV with params:", csvParams);
    this.props.getSRTimelineCSVExport(csvParams);
  };

  render() {
    /** ---------- LOCATION SELECT ---------- */
    const locationOptions =
      this.props.userLocation?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || [];

    const selectedLocation =
      locationOptions.find(
        (opt) => opt.value === this.props.params?.location,
      ) || null;

    /** ---------- SR CODE SELECT ---------- */
    const srCodeOptions =
      this.props.SRQ_REPORTS_LIST?.reduce((acc, item, index) => {
        if (item.sr_no && !acc.find((opt) => opt.value === item.sr_no)) {
          acc.push({
            label: item.sr_no,
            value: item.id,
          });
        }
        return acc;
      }, []) || [];

    const selectedSRCode =
      srCodeOptions.find((opt) => opt.value === this.props.params?.sr_id) ||
      null;

    return (
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <Link to="/reports" className="action-icon text-primary mr-2">
                    <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20" />
                  </Link>
                  <h5 className="card-title-18 pt-2 d-inline-block">
                    SR TIMELINE REPORT
                  </h5>
                </CardHeader>

                <CardBody>
                  <Row>
                    {/* From Date */}
                    <Col md={3}>
                      <FormGroup>
                        <Label>From Date</Label>
                        <Input
                          type="date"
                          name="start_date"
                          value={
                            this.props.params.start_date ||
                            moment(new Date(y, m, 1)).format("YYYY-MM-DD")
                          }
                          onChange={this.ReportsChangeHandeler}
                          max={moment().format("YYYY-MM-DD")}
                        />
                      </FormGroup>
                    </Col>

                    {/* To Date */}
                    <Col md={3}>
                      <FormGroup>
                        <Label>To Date</Label>
                        <Input
                          type="date"
                          name="end_date"
                          value={
                            this.props.params.end_date ||
                            moment().format("YYYY-MM-DD")
                          }
                          onChange={this.ReportsChangeHandeler}
                          min={
                            this.props.params.start_date ||
                            moment(new Date(y, m, 1)).format("YYYY-MM-DD")
                          }
                          max={moment().format("YYYY-MM-DD")}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      <FormGroup className="mb-0">
                        <Label
                          htmlFor="sritems__product"
                          className="col-form-label"
                        >
                          Products :
                        </Label>

                        <Select
                          id="sritems__product"
                          name="sritems__product"
                          classNamePrefix="select2-selection"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={
                            this.props.miniProductList?.results?.map(
                              (item) => ({
                                label: `${item.name} - ${item.code}`,
                                value: item.id,
                              }),
                            ) || []
                          }
                          /* 🔍 Search */
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") {
                              this.props.getMiniProductList({
                                ...this.props.miniProductParams,
                                page: 1,
                                page_size: 10,
                                search: inputValue,
                              });
                            }
                          }}
                          /* 📂 Initial load */
                          onMenuOpen={() => {
                            this.props.getMiniProductList({
                              ...this.props.miniProductParams,
                              page: 1,
                              page_size: 10,
                              search: "",
                            });
                          }}
                          /* ⬇ Pagination */
                          onMenuScrollToBottom={() => {
                            if (
                              this.props.miniProductParams.page <
                              this.props.miniProductParams.no_of_pages
                            ) {
                              this.props.getMiniProductList({
                                ...this.props.miniProductParams,
                                page: this.props.miniProductParams.page + 1,
                                page_size: 10,
                              });
                            }
                          }}
                          /* ✅ Correct value binding */
                          value={
                            this.props.params?.sritems__product
                              ? {
                                  label:
                                    this.props.miniProductList?.results?.find(
                                      (p) =>
                                        p.id ===
                                        this.props.params.sritems__product,
                                    )?.name,
                                  value: this.props.params.sritems__product,
                                }
                              : null
                          }
                          /* ✅ Correct change handler */
                          onChange={(e) => {
                            this.props.ReportsSelecteChangeValue({
                              key: "sritems__product_label",
                              label: e?.label,
                              key2: "sritems__product",
                              value: e?.value,
                            });
                          }}
                          isClearable
                          placeholder="Select Product"
                        />
                      </FormGroup>
                    </Col>

                    {/* Location - MANDATORY */}
                    <Col md={3}>
                      <FormGroup>
                        <Label>
                          Locations <span className="text-danger">*</span>
                        </Label>
                        <Select
                          options={locationOptions}
                          value={selectedLocation}
                          onChange={(e) =>
                            this.SelecteChangeValue({
                              key: "locationlabel",
                              label: e?.label,
                              key2: "location",
                              value: e?.value,
                            })
                          }
                          isClearable
                          placeholder="Select Location"
                          isRequired
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: !this.props.params?.location
                                ? "#dc3545"
                                : base.borderColor,
                              borderWidth: !this.props.params?.location
                                ? "2px"
                                : base.borderWidth,
                            }),
                          }}
                        />
                        {!this.props.params?.location && (
                          <small className="text-danger">
                            Location is required
                          </small>
                        )}
                      </FormGroup>
                    </Col>

                    {/* Report Type */}
                    <Col md={3} className="text-center">
                      <Label className="d-block">&nbsp;</Label>

                      <div className="border p-2 d-flex justify-content-center gap-4">
                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="reportType"
                              value="csv"
                              checked={this.props.reportType === "csv"}
                              onChange={(e) => this.reportType(e)}
                            />{" "}
                            CSV
                          </Label>
                        </FormGroup>

                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="reportType"
                              value="document"
                              checked={this.props.reportType === "document"}
                              onChange={(e) => this.reportType(e)}
                            />{" "}
                            Document
                          </Label>
                        </FormGroup>
                      </div>
                    </Col>

                    {/* SR Code */}
                    {this.props.reportType === "document" && (
                      <Col md={3}>
                        <FormGroup>
                          <Label>SR Code</Label>
                          <Select
                            options={srCodeOptions}
                            value={selectedSRCode}
                            onChange={(e) => {
                              console.log("SR selected:", e);
                              this.SelecteChangeValue({
                                key: "SRCodelabel",
                                label: e?.label,
                                key2: "sr_id",
                                value: e?.value,
                              });
                            }}
                            isClearable
                            placeholder="Select SR Code"
                          />
                        </FormGroup>
                      </Col>
                    )}
                  </Row>

                  {/* Generate Button */}
                  <Row>
                    <Col md={12} className="text-right">
                      {this.props.reportType === "document" ? (
                        <Link
                          to={`/srtimelinereportdoc/${this.props.params.sr_id}`}
                          onClick={this.handleGenerateReport}
                        >
                          <Button
                            color="primary"
                            disabled={
                              !this.props.params.sr_id ||
                              !this.props.params?.location
                            }
                          >
                            Generate Report
                          </Button>
                        </Link>
                      ) : (
                        <Button
                          color="primary"
                          onClick={this.handleDownloadCSV}
                          disabled={!this.props.params?.location}
                        >
                          Download CSV
                        </Button>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { userLocation, miniProductList, miniProductParams } = state.Mini;
  const { params, reportType, SRTimeLine_Doc_report, SRQ_REPORTS_LIST } =
    state.reports;

  return {
    userLocation,
    reportType,
    params,
    SRTimeLine_Doc_report,
    SRQ_REPORTS_LIST,
    miniProductList,
    miniProductParams,
  };
};

export default connect(mapStateToProps, {
  getUserLocations,
  getSRTimelLinereportslist,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
  SRTimelLinereportslistSuccessful,
  getMiniProductList,
  getSRTimelineCSVExport,
})(SRTimelLineReports);
